<template>
  <div class="message-warp" @touchmove="hideMessage">
    <div class="message-content">
      <div class="message-text">{{ $store.state.messageContent }}</div>
      <div class="message-btn" @click="hideMessage">OK</div>
    </div>
  </div>
</template>

<script>
import { baseOssUrl } from "@/util/config";
const clientWidth =
  window.innerWidth ||
  document.body.clientWidth ||
  document.documentElement.clientWidth;
const baseSize = .85 * (clientWidth > 640 ? 1 : clientWidth / 640);
export default {
  data() {
    return {
      baseOssUrl,
      baseSize
      // defaultPrize: [],
      // prizeReSort: []
    };
  },
  props: {
    content: []
  },
  mounted() {},
  methods: {
    hideMessage() {
      this.$store.commit("updateValue", ["showMessage", false]);
    }
  }
};
</script>

<style scoped lang="scss">
.message-warp {
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  left: 50%;
  transform: translate(-50%,0);
  top: 0;
  width: 100%;
  max-width: 640px;
  height: 100%;
  z-index: 99999;
}
.message-content {
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  padding: 40px 40px 76px;
  font-size: 16px;
  text-align: center;
  background: #fff;
  border-radius: 4px;
  z-index: 99999;
  .message-text {
    display: flex;
    align-items: center;
    min-height: 40px;
    line-height: 20px;
    justify-content: center;
  }
  .message-btn {
    border-top: 1px solid #eee;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    color: #5e9e50;
    line-height: 44px;
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LuckDraw/Message.vue